<template>

    <m-edit1/>

    <m-mini-profile-1 v-bind='{...{},...{}}' :style='"border-radius: 25px;"' class="container bg-white border my-2" ></m-mini-profile-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mMiniProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/MiniProfile/MiniProfile1';

export default {
    name: 'HomeView',
    components: {mEdit1, mMiniProfile1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
